import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import shadows, { Shadows } from "@mui/material/styles/shadows";
import React from "react";

interface IThemeDefaultComponentProps {
    children: React.ReactNode;
}

const font = "'Open Sans', sans-serif";

const ThemeDefaultComponent = ({ children }: IThemeDefaultComponentProps) => {
    const loginTheme = createTheme({
        palette: {
            primary: {
                main: "#45A779",
                // light: "#6AB893",
                // dark: "#307454",
                contrastText: "#fff",
            },
        },
        typography: {
            fontFamily: font,
            fontWeightMedium: 500,
            fontWeightBold: 700,
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        backgroundColor: "#45A779",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        boxShadow: shadows.map(() => "none") as Shadows,
                    },
                },
            },
        },
    });
    return (
        <ThemeProvider theme={loginTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default ThemeDefaultComponent;
